module.exports = __webpack_public_path__ + "img/enterData.b8e991fe.svg";